export default __webpack_public_path__ + "static/media/btechCloud.ddda79cf.png";